import { FeedbackClassification } from '../store/schema/FeedbackClassification';
import { assertNever } from 'owa-assert';

export function getCategoryDisplayEmoji(type: FeedbackClassification): string {
    switch (type) {
        case FeedbackClassification.Bug:
            return '🐞';
        case FeedbackClassification.FeatureRequest:
            return '🎁';
        case FeedbackClassification.Compliment:
            return '💖';
        default:
            return assertNever(type);
    }
}
